export default {"src":"/_next/static/media/profile-difficulties.a99201c4.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};